enum LDDRadioButtonValue {
  FIXED_TIME = '1',
  LEAD_TIME_AFTER_EDD = '2',
  LEAD_TIME_AFTER_LSD = '3',
}

export default LDDRadioButtonValue
